import axios from "axios";
import { verifyToken } from "utils/Funciones";
import { BACKEND } from "utils/contants";
const API_URL = `${BACKEND}/api/consultareniec/`;

const getByDocumentId = async (query, token) => {
    const response = await axios.get(API_URL + `${query}`, {
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
    });
    return response.data;
};

const consultaReniecService = {
    getByDocumentId,
};

export default consultaReniecService;
